import { FieldConfig } from '../ModalFieldRenderer';
import { Grade } from '../../../services/api/domains/grades/types';
import {
  toModalFields,
  getAlwaysDisabledFields,
} from '../../../domains/grades/adapters';

export const gradeFields: FieldConfig<Grade>[] = toModalFields();

export const gradeAlwaysDisabledFields: string[] = getAlwaysDisabledFields();
